export default __webpack_public_path__ + "static/media/game_process_preview.e02e8bcb.png";